import {
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  GeneralTable,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Button, Grid } from "@mui/material";
import { useMemo, useState } from "react";
import { useFetchBodegas } from "@/shared/actions/erp";
import AddIcon from "@mui/icons-material/Add";
import { BODEGAS } from "@/shared/interfaces/erp/inventario";
import { MRT_ColumnDef } from "material-react-table";

interface ModalBodegaUsuarioProps {
  onChange: (e: BODEGAS) => void;
  iconButton?: boolean;
  textButton?: string;
  onlyShow?: boolean;
}

export default function ModalBodegaUsuario({
  onChange,
  textButton = "Agregar",
}: ModalBodegaUsuarioProps) {
  ///* State
  const [openModal, setOpenModal] = useState<boolean>(false);

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  //FETCH
  const {
    isLoading: isloadingBodega,
    data: bodegaRes,
    isRefetching: isRefetchingBodega
  } = useFetchBodegas({
    page: pageIndex + 1,
    page_size: pageSize,
    estado: true,
    filterByState: false,
    // Picker de administración: pide TODAS las bodegas para poder asignarlas.
    // El backend solo lo honra si el usuario tiene el módulo USUARIOS.USUARIOS.
    todas_bodegas: true,
    ...filterObject,
  },
    true,
  );

  useLoaders(isloadingBodega);


  const columns = useMemo<MRT_ColumnDef<BODEGAS>[]>(
    () => [
      {
        id: 'nombre',
        accessorKey: 'nombre',
        header: 'nombre',
      },
    ],
    []
  );


  return (
    <>
      <Button
        startIcon={<AddIcon />}
        variant="outlined"
        onClick={() => {
          setOpenModal(true)
        }}
      >
        {textButton}
      </Button>

      {openModal && (
        <ScrollableDialogProps
          open={openModal}
          title="Seleccionar"
          onCloseIcon={() => {
            setOpenModal(false);
          }}
          minWidth="60%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <GeneralTable<BODEGAS>
                  columns={columns}
                  data={bodegaRes?.data.data || []}
                  isLoading={isloadingBodega}
                  isRefetching={isRefetchingBodega}
                  enableGlobalFilter={false}
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={bodegaRes?.data?.count}
                  actionsColumnSize={120}
                  canDelete={false}
                  positionActionsColumn='first'
                  enableColumnActions={true}
                  canAdd={true}
                  canEdit={false}
                  onAdd={e => {
                    onChange(e);
                  }}
                  density="comfortable"
                  enableTopToolbar={false}

                  ///* filters - server side
                  enableSorting={false}
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}

                />
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
